import { useState, useEffect, useRef, useCallback } from "react";
import "./App.css";
import { ThemeProvider } from "./context/ThemeContext";
import { warmUpChatServer } from "./componenets/terminal/commands";
import InteractiveTerminal from "./componenets/terminal/InteractiveTerminal";
import AboutSection from "./componenets/about/AboutSection";
import CurrentlySection from "./componenets/currently/CurrentlySection";
import EducationSection from "./componenets/education/EducationSection";
import ExperienceSection from "./componenets/experience/ExperienceSection";
import ProjectsSection from "./componenets/projects/ProjectsSection";
import SkillsSection from "./componenets/skills/SkillsSection";
import Footer from "./componenets/footer/Footer";

function App() {
  const [hoveredSkill, setHoveredSkill] = useState(null);
  const [collapseOtherSections, setCollapseOtherSections] = useState(false);
  const [pendingCommand, setPendingCommand] = useState(null);
  const mobileTerminalRef = useRef(null);

  useEffect(() => {
    warmUpChatServer();
  }, []);

  const handleTerminalCommand = useCallback((cmd) => {
    setPendingCommand(cmd);
    // On mobile, scroll the terminal into view
    if (mobileTerminalRef.current && window.innerWidth < 1024) {
      mobileTerminalRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, []);

  return (
    <ThemeProvider>
      <div
        className="relative h-screen w-screen"
        style={{ background: "var(--bg-secondary)" }}
      >
        <div className="flex flex-col lg:flex-row h-full w-full overflow-hidden">
          {/* Left Column (mobile: full page scrollable) */}
          <main className="w-full lg:w-[50%] h-screen overflow-y-auto flex flex-col pt-12 lg:pt-24 px-8 lg:pl-36 lg:pr-12 pb-24">
            <div>
              <AboutSection />
              <CurrentlySection forceCollapsed={collapseOtherSections} />

              {/* Terminal on mobile (above Education) */}
              <div className="lg:hidden" ref={mobileTerminalRef}>
                <div
                  className="border-t my-4"
                  style={{ borderColor: "var(--border-color)" }}
                />
                <div className="pb-4" style={{ height: "400px" }}>
                  <InteractiveTerminal
                    pendingCommand={pendingCommand}
                    onCommandConsumed={() => setPendingCommand(null)}
                  />
                </div>
                <div
                  className="border-t my-4"
                  style={{ borderColor: "var(--border-color)" }}
                />
              </div>

              <EducationSection forceCollapsed={collapseOtherSections} />
              <ExperienceSection
                hoveredSkill={hoveredSkill}
                forceCollapsed={collapseOtherSections}
                onTerminalCommand={handleTerminalCommand}
              />
              <ProjectsSection
                hoveredSkill={hoveredSkill}
                onCollapseOthersChange={setCollapseOtherSections}
                onTerminalCommand={handleTerminalCommand}
              />

              {/* Skills + Terminal on mobile only */}
              <div className="lg:hidden">
                <div
                  className="border-t my-4"
                  style={{ borderColor: "var(--border-color)" }}
                />
                <SkillsSection
                  onSkillHover={setHoveredSkill}
                  hoveredSkill={hoveredSkill}
                />
              </div>
            </div>
          </main>

          {/* Right Column: Skills + Terminal (desktop only) */}
          <aside className="hidden lg:flex flex-col w-[50%] pl-12 pr-36 h-screen sticky top-0 py-24 border-none">
            <SkillsSection
              onSkillHover={setHoveredSkill}
              hoveredSkill={hoveredSkill}
            />
            <div
              className="border-t my-4"
              style={{ borderColor: "var(--border-color)" }}
            />
            <div className="flex-1 min-h-0">
              <InteractiveTerminal
                pendingCommand={pendingCommand}
                onCommandConsumed={() => setPendingCommand(null)}
              />
            </div>
          </aside>
        </div>
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default App;
